module.exports = __webpack_public_path__ + "static/media/jeeExam.d734ec02.png";